import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

export const MaintenanceBanner = ({ message }: { message?: string | null }) => (
	<Box
		role="status"
		sx={{
			width: "100%",
			flexShrink: 0,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			gap: 1,
			px: 2,
			py: 1,
			bgcolor: "info.main",
			color: "info.contrastText",
		}}>
		<InfoOutlined sx={{ flexShrink: 0 }} />
		<Typography
			variant="body2"
			sx={{ textAlign: "center", overflowWrap: "anywhere" }}>
			{message?.trim() ||
				"The system is under maintenance. Some actions are unavailable."}
			{!!process.env.SYSTEM_STATUS_URL && (
				<>
					{" "}
					<Link
						href={process.env.SYSTEM_STATUS_URL}
						target="_blank"
						rel="noopener noreferrer"
						color="inherit"
						underline="always">
						System status
					</Link>
				</>
			)}
		</Typography>
	</Box>
);
